import React from "react";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGS } from "@/i18n";
import { Globe } from "lucide-react";

/**
 * LanguageToggle — compact EN / हिं pill in header.
 * Persists choice in localStorage via i18next language detector.
 */
export default function LanguageToggle() {
    const { i18n, t } = useTranslation();
    const current = (i18n.language || "en").split("-")[0];

    const setLang = (code) => {
        if (code !== current) i18n.changeLanguage(code);
    };

    return (
        <div
            className="inline-flex items-center gap-1 border border-[var(--np-border)] text-[11px] uppercase tracking-widest"
            role="group"
            aria-label={t("language.switch")}
            data-testid="language-toggle"
        >
            <span className="hidden sm:inline-flex items-center pl-2 pr-1 text-[var(--np-text-muted)]">
                <Globe size={11} />
            </span>
            {SUPPORTED_LANGS.map((l) => (
                <button
                    key={l.code}
                    type="button"
                    onClick={() => setLang(l.code)}
                    data-testid={`lang-btn-${l.code}`}
                    className={
                        "px-2.5 py-1.5 transition-colors " +
                        (l.code === current
                            ? "bg-[var(--np-brand)] text-white"
                            : "text-[var(--np-text-2)] hover:text-[var(--np-text)]")
                    }
                    aria-pressed={l.code === current}
                >
                    {l.short}
                </button>
            ))}
        </div>
    );
}
